import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { BookingCurrency } from '../../services/booking/currency';

export const PriceDisplay = ({ value, intl }) => {
  const priceString = intl.formatNumber(value, {
    style: 'currency',
    currency: BookingCurrency.USD,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return priceString.replace(/\.[0-9][0-9]$/, '');
};

PriceDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  intl: PropTypes.object,
};

export default injectIntl(PriceDisplay);
